<template>
  <div>
    <transition name="fold">
      <div class="sidebar" v-show="sidebarShow">
        <menu-layout v-on:hide="hide"></menu-layout>
      </div>
    </transition>
    <transition name="fade">
      <div class="mask" @click.stop.prevent="hide" v-show="sidebarShow"></div>
    </transition>
  </div>
</template>

<script>
import MenuLayout from "../views/layout/MenuLayout";
export default {
  name: 'Sidebar',
  components:{
    MenuLayout,
  },
  props: {
    sidebarShow: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      data:[]
    }
  },
  methods:{
    //隐藏侧边栏,向上派发事件(向父组件传值)
    hide() {
      this.$emit('hideSidebar', false);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.sidebar{
  position: fixed;
  top: 0px;
  right: 0px;
  z-index: 50;
  height: 100%;
  width: 230px;
  // background-color: rgb(35, 42, 48);
  background-color: #fff;
  transform: translate3d(0, 0, 0);
}
.mask{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 40;
  background: rgba(7, 17, 27, 0.6);
  opacity: 1;
  &.fade-enter-active, &.fade-leave-active{
    transition: all 0.5s;
  }
  &.fade-enter, &.fade-leave-active{
    opacity: 0;
  }
}
</style>
